import { createSlice } from "@reduxjs/toolkit";
import {
  getDashboardEditThunk,
  getDashboardListing,
} from "../thunk/dashboardThunk";
import { reset } from "ol/transform";
import { app } from "@config/firebaseConfig";

type ApplicationDashboardState = {
  id: number;
  start_chainage?: string;
  end_chainage?: string;
  application_code?: string;
  status_id?: number;
};

const initialState: ApplicationDashboardState = {
  id: 0,
  start_chainage: "",
  end_chainage: "",
  application_code: "",
  status_id: 0,
};

const ApplicationDashboardSlice = createSlice({
  name: "details",
  initialState,
  reducers: {
    resetApplicationDashboardState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardEditThunk.pending, (state) => {
        state.id = 0;
        state.start_chainage = "";
        state.end_chainage = "";
        state.application_code = "";
        state.status_id = 0;
      })
      .addCase(getDashboardEditThunk.fulfilled, (state, action) => {
        state.id = action.payload.data.id || 0;
        state.start_chainage = action.payload.data.start_chainage || "";
        state.end_chainage = action.payload.data.end_chainage || "";
        state.application_code = action.payload.data.application_code || "";
        state.status_id = action.payload.data.status_id || 0;
      })
      .addCase(getDashboardEditThunk.rejected, (state, action) => {
        state.id = 0;
        state.start_chainage = "";
        state.end_chainage = "";
        state.status_id = 0;
      });
  },
});

export const { resetApplicationDashboardState } =
  ApplicationDashboardSlice.actions;

export default ApplicationDashboardSlice.reducer;
